import React, { Component } from 'react';
import './darkOverlay.css';

class DarkOverlay extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div className="darkOverlay" />
        );
    }
}

export default DarkOverlay;